import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import React, { Component } from "react";
import { enableRtl } from "@syncfusion/ej2-base";
import { Button, Spinner } from "react-bootstrap";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import { Query } from "@syncfusion/ej2-data";
import NumberFormat from "react-number-format";
import { Redirect } from "react-router-dom";
import dateicon from "../assets/dateicon.png";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

enableRtl(true);

export default class DPS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitedSuggestion: [],
      dpsAuto: true,
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: "",
      quantitychange: "",
      chashchange: "",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      basketValue: "",
      Redirect: false,
      dateErrorText: "",
      symbolErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      cashFalse: false,
      basketFalse: false,
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      options: [],
      isLoading: false,
      currenttseid: "",
      buttonDisabled: false,
      buttonSpinner: false,
      buttonDisabledDivision: false,
      buttonSpinnerDivision: false,
      isEdit: null,
    };

    this.fields = { value: "full_name" };
    this.fields1 = { value: "lable" };
    this.query = new Query().where("type_code", "notequal", 7);
    this.cashchange = this.cashchange.bind(this);
    this.quantitychange = this.quantitychange.bind(this);
    this.suggestionSubmit = this.suggestionSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.getSymbol = this.getSymbol.bind(this);

    this.datepickerr = React.createRef();
  }

  searchSymbol(query) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "stick",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result, isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getSymbol(query, id) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };
    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result }, () => {
            resultt.result.forEach((element) => {
              if (element.id === id) {
                let s = [];
                s.push(element);
                this.setState({ selectedSymbol: element, selectedSymbol1: s });
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.dpsAuto) {
      if (prevProps.userBasketsData !== this.props.userBasketsData) {
        if (this.props.userBasketsData.length > 1) {
          this.acBaskets.readonly = false;
        } else {
          this.acBaskets.readonly = true;
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue: value });
  }

  acSymbolChange(item) {
    try {
      if (item.length < 1) {
        this.setState({ selectedSymbol: null, selectedSymbol1: null });
        return;
      }
      let s = [];
      s.push(item[0]);
      this.setState({ selectedSymbol: item[0], selectedSymbol1: s });
    } catch (error) {}
  }

  acBasketChange() {
    this.setState({ selectedBasket: this.acBaskets.value });
  }

  SubmitFrom() {
    try {
      let selectbasket;
      if (!this.state.dpsAuto) selectbasket = this.acBaskets.value;
      // let date=this.convertDate(this.state.dateValue);
      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let symbolid;
      if (this.state.selectedSymbol !== null)
        symbolid = this.state.selectedSymbol.id;
      let basketid = null;
      let type;

      if (!this.state.dpsAuto) {
        this.props.userBasketsData.forEach(function (entry) {
          if (entry.lable === selectbasket) {
            basketid = entry.id;
          }
        });
      }
      type = "submitDPS";

      let cash = this.state.chashchange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      let indexofelement = 1;
      if (this.props.isPopup) indexofelement = 0;
      if (this.state.selectedSymbol === null) {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid var(--red1)";
        this.setState({
          symbolFalse: true,
          symbolErrorText: "نام نماد باید وارد شود",
        });
        return;
      } else {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid #ced4da";
        this.setState({ symbolFalse: false, symbolErrorText: "" });
      }

      if (cash === "") {
        this.setState({ cashFalse: true, cashErrorText: "مبلغ نامعتبر است" });
        return;
      } else if (Number(cash) < 1) {
        this.setState({
          cashFalse: true,
          cashErrorText: "مبلغ نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ cashFalse: false, cashErrorText: "" });
      }

      if (!this.state.dpsAuto) {
        if (
          this.acBaskets.value === null ||
          this.acBaskets.value === "" ||
          basketid === undefined
        ) {
          this.setState({
            basketFalse: true,
            basketErrorText: "نام سبد نامعتبر است",
          });
          return;
        } else {
          this.setState({ basketFalse: false, basketErrorText: "" });
        }
      }

      let list = [];

      if (this.state.dpsAuto) {
        this.state.submitedSuggestion.forEach(function (entry) {
          if (entry.price > 0) {
            var d = { basket_id: entry.id, cash_change: entry.price };
            list.push(d);
          }
        });
      } else {
        var d = { basket_id: basketid, cash_change: cash };
        list.push(d);
      }

      if (this.state.dpsAuto && this.state.submitedSuggestion.length === 0) {
        this.submitDivision();
        return;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        date: date,
        symbol_id: symbolid,
        symbol_type: this.state.selectedSymbol.type_code,
        type: type,
        list: list,
      };

      if (this.state.isEdit) {
        this.editAction(data, 0, basketid, cash);
        return;
      }

      this.setState({ buttonDisabled: true, buttonSpinner: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.submitDPSDevisionSuccess();
            this.props.onRefresh(0, basketid);
            this.resetForm();
            toast.success("سند مورد نظر با موفقیت ثبت گردید", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabled: false, buttonSpinner: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false, buttonSpinner: false });
    }
  }

  cashchange(event) {
    this.setState({ chashchange: event.target.value });
  }

  quantitychange(event) {
    this.setState({ quantitychange: event.target.value });
  }

  setBasketValue(name, readonly) {
    if (!this.state.dpsAuto) {
      this.acBaskets.value = name;
      this.acBaskets.readonly = readonly;
    }
  }

  submitDivision() {
    try {
      let symbolid;
      if (this.state.selectedSymbol !== null)
        symbolid = this.state.selectedSymbol.id;
      let cash = this.state.chashchange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");
      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        symbol_id: symbolid,
        symbol_type: this.state.selectedSymbol.type_code,
        total: cash,
        type: "DPS",
      };

      this.setState({
        buttonDisabled: true,
        buttonSpinner: false,
        buttonDisabledDivision: true,
        buttonSpinnerDivision: true,
      });
      fetch("/api/suggestDivision", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            if (resultt.result.length > 0) {
              this.props.showSuggestion(resultt.result, cash);
            } else {
              toast.error("نماد مورد نظر در هیچ یک از سبدها موجود نیست", {
                position: toast.POSITION.BOTTOM_LEFT,
                hideProgressBar: true,
                autoClose: 8000,
                toastClassName: "toast",
              });
            }
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({
            buttonDisabled: false,
            buttonSpinner: false,
            buttonDisabledDivision: false,
            buttonSpinnerDivision: false,
          });
        });
    } catch (error) {
      this.setState({
        buttonDisabled: false,
        buttonSpinner: false,
        buttonDisabledDivision: false,
        buttonSpinnerDivision: false,
      });
    }
  }

  check1Change() {
    if (this.check1.checked) {
      this.setState({ dpsAuto: true });
    } else {
      this.setState({ dpsAuto: false });
    }
  }

  suggestionSubmit(data) {
    this.setState({ submitedSuggestion: data }, () => {
      this.SubmitFrom();
    });
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      chashchange: "",
      isEdit: null,
      selectedSymbol: null,
      selectedSymbol1: null,
      submitedSuggestion: [],
      dateErrorText: "",
      symbolErrorText: "",
      cashErrorText: "",
      basketErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      cashFalse: false,
      basketFalse: false,
    });
    document.querySelectorAll(".rbt-input-main")[1].style.border =
      "1px solid #ced4da";
    this.acSymbol.clear();
    if (
      this.props.selectedPortfolioId === 0 &&
      this.props.userBasketsData.length > 1 &&
      !this.state.dpsAuto
    ) {
      this.acBaskets.value = "";
    }
  }

  editFrom(data) {
    this.check1.checked = false;

    this.setState(
      {
        chashchange: Math.abs(data.cash_change),
        dpsAuto: false,
        dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
      },
      () => {
        if (this.props.userBasketsData.length > 1) {
          this.acBaskets.value = data.basket;
        }
      }
    );

    this.getSymbol(data.symbol, data.symbol_id);
    this.setState({ isEdit: data });
  }

  editAction(body, brokerid, basketid, cash) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;

    data.basket_id = basketid;
    data.cash_change = cash;

    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent" style={{ minHeight: "340px" }}>
          {/* <div style={{width:'100%'}}>
                        <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRedDate":"form-control inputStyleFormDate"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        />
                    </div> */}
          <div className="InputWithIcon" style={{ direction: "ltr" }}>
            <div className="inputImageDiv">
              <img src={dateicon} className="inputImage" alt="date" />
            </div>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        /> */}
            <DatePicker
              ref={this.datepickerr}
              value={this.state.dateValue}
              inputClass={
                this.state.dateFalse
                  ? "form-control inputStyleRed"
                  : "form-control inputStyleForm"
              }
              calendar="persian"
              locale="fa"
              weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
              format="YYYY/MM/DD"
              animation
              className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
              onChange={(valuee) => this.dateChange(valuee)}
              maxDate={this.state.maxDateStart}
              editable={false}
              inputMode="none"
              fixMainPosition={true}
              fixRelativePosition={true}
              placeholder="تاریخ"
            />
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>
          {/* <AutoCompleteComponent className={this.state.symbolFalse ? "inputStyleRed":"inputStyleForm"} ref={(scope) => this.acSymbol = scope} enableRtl='true' noRecordsTemplate="موردی یافت نشد" allowCustom={false} filterType="Contains" popupHeight="550px" dataSource={this.props.symbolsData} fields={this.fields} placeholder="نماد" autofill={true} /> */}
          <AsyncTypeahead
            id="dpsSymbol"
            searchText="در حال جستجو..."
            promptText="لطفاً نام نماد مورد نظر را تایپ کنید"
            paginationText="نمایش موارد بیشتر ..."
            useCache={true}
            ref={(scope) => (this.acSymbol = scope)}
            isLoading={this.state.isLoading}
            labelKey="full_name"
            minLength={2}
            onSearch={this.searchSymbol.bind(this)}
            onInputChange={(text) => {
              if (text === "")
                this.setState({ selectedSymbol: null, selectedSymbol1: null });
            }}
            options={this.state.options}
            placeholder="نماد"
            delay={100}
            emptyLabel="موردی یافت نشد"
            flip={true}
            clearButton={true}
            onChange={this.acSymbolChange.bind(this)}
            selected={this.state.selectedSymbol1}
          />
          <div className="errorMessage1">{this.state.symbolErrorText}</div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <CheckBoxComponent
              disabled={this.state.isEdit}
              className="checkBoxContainer"
              label="تقسیم خودکار سود به نسبت سبدها"
              checked
              ref={(scope) => (this.check1 = scope)}
              change={this.check1Change.bind(this)}
              enableRtl="true"
            />
          </div>

          <div className="dpsCostContainer">
            <div className="dpsTextContainer">
              <NumberFormat
                placeholder={
                  this.state.dpsAuto ? "مبلغ سود به ازای هر سهم" : "مبلغ کل سود"
                }
                className={
                  this.state.cashFalse
                    ? "form-control inputStyleRed"
                    : "form-control inputStyleForm"
                }
                displayType={"input"}
                thousandSeparator={true}
                suffix={" ریال"}
                onChange={this.cashchange}
                value={this.state.chashchange}
              />
            </div>
            {/* {this.state.dpsAuto && <Button variant="secondary" className="dpsButtonStyle" disabled={this.state.chashchange!==null && this.state.chashchange!=='' && this.state.selectedSymbol!==null && !this.state.buttonDisabledDivision ? false:true} onClick={this.submitDivision.bind(this)}>{this.state.buttonSpinnerDivision && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonSpinnerDivision && <div>محاسبه</div>}</Button>} */}
          </div>
          <div className="errorMessage1">{this.state.cashErrorText}</div>

          {!this.state.dpsAuto && (
            <AutoCompleteComponent
              showPopupButton={true}
              className={
                this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
              }
              ref={(scope) => (this.acBaskets = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="550px"
              dataSource={this.props.userBasketsData}
              fields={this.fields1}
              placeholder="سبد"
              autofill={true}
            />
          )}
          <div className="errorMessage1">{this.state.basketErrorText}</div>
          {/* <ButtonComponent cssClass='e-primary' onClick={this.SubmitFrom.bind(this)}>ثبت سند</ButtonComponent> */}
          {/* <Button variant="secondary" style={{width:'50%',fontSize:'13px',marginTop:'20px',height:'30px'}} onClick={this.SubmitFrom.bind(this)}>ثبت</Button> */}
          {!this.state.isEdit && !this.props.isPopup && !this.state.dpsAuto && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonSpinner && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonSpinner && <div>ثبت</div>}
            </Button>
          )}
          {!this.state.isEdit && !this.props.isPopup && this.state.dpsAuto && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabledDivision}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonSpinnerDivision && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonSpinnerDivision && <div>تایید</div>}
            </Button>
          )}
          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              {!this.state.dpsAuto && (
                <Button
                  variant={this.state.isEdit ? "primary" : "secondary"}
                  style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                  disabled={this.state.buttonDisabled}
                  onClick={this.SubmitFrom.bind(this)}
                >
                  {this.state.buttonSpinner && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinner && this.state.isEdit && (
                    <div>ویرایش</div>
                  )}
                  {!this.state.buttonSpinner && !this.state.isEdit && (
                    <div>ثبت</div>
                  )}
                </Button>
              )}
              {this.state.dpsAuto && (
                <Button
                  variant={this.state.isEdit ? "primary" : "secondary"}
                  style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                  disabled={this.state.buttonDisabledDivision}
                  onClick={this.SubmitFrom.bind(this)}
                >
                  {this.state.buttonSpinnerDivision && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinnerDivision && this.state.isEdit && (
                    <div>ویرایش</div>
                  )}
                  {!this.state.buttonSpinnerDivision && !this.state.isEdit && (
                    <div>تایید</div>
                  )}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
